// Auto Square Fix for tall product images
document.addEventListener('DOMContentLoaded', function() {
  function fixTallImages() {
    document.querySelectorAll('.product-gallery__image').forEach(function(img) {
      if (img.complete && img.naturalHeight > 0) {
        applyFix(img);
      } else {
        img.addEventListener('load', function() {
          applyFix(img);
        });
      }
    });
  }

  function applyFix(img) {
    var ratio = img.naturalHeight / img.naturalWidth;
    if (ratio > 1.2) {
      img.style.maxHeight = '400px';
      img.style.width = 'auto';
      img.style.objectFit = 'contain';
      img.style.display = 'block';
      img.style.margin = '0 auto';
      // Force the Flickity viewport to shrink
      var viewport = document.querySelector('.product-gallery__carousel .flickity-viewport');
      if (viewport) {
        viewport.style.height = '400px';
      }
    }
  }

  setTimeout(fixTallImages, 800);

  document.addEventListener('click', function() {
    setTimeout(fixTallImages, 500);
  });
});
// Quick view "Email me when available" -> open the SW Back in Stock popup.
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('.qv-notify-btn');
  if (!link) return;

  var id = link.getAttribute('data-product-id');
  var wrapper = id && document.querySelector('.restore-email-wrapper[proid="' + id + '"]');
  var btn = wrapper && wrapper.querySelector('.email-me-button');
  if (!btn) return;

  e.preventDefault();

  var modal = link.closest('.modal');
  var close = modal && modal.querySelector('[data-action="close-modal"]');
  if (close) close.click();

  setTimeout(function () { btn.click(); }, 350);
});
// Let the app's injected restock button open its popup inside a card.
document.addEventListener('click', function (e) {
  if (e.target.closest && e.target.closest('.hl-product-card .restore-email-wrapper')) {
    e.preventDefault();
  }
}, true);
// Let the app's injected restock button open its popup inside a card.
document.addEventListener('click', function (e) {
  if (e.target.closest && e.target.closest('.hl-product-card .restore-email-wrapper')) {
    e.preventDefault();
  }
}, true);


// Quick view "Email me when available" -> open the SW Back in Stock popup.
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('.qv-notify-btn');
  if (!link) return;

  var id = link.getAttribute('data-product-id');
  var wrapper = id && document.querySelector('.restore-email-wrapper[proid="' + id + '"]');
  var btn = wrapper && wrapper.querySelector('.email-me-button');
  if (!btn) return;

  e.preventDefault();

  var modal = link.closest('.modal');
  var close = modal && modal.querySelector('[data-action="close-modal"]');
  if (close) close.click();

  setTimeout(function () { btn.click(); }, 350);
});
// Quick view: start the gallery images loading as soon as the markup lands.
document.addEventListener('shopify:section:load', function (e) {
  if (!e.target || !e.target.closest || !e.target.closest('#hl-quick-view-modal')) { return; }
  var modal = document.getElementById('hl-quick-view-modal');
  if (!modal) { return; }

  function unveil(el) {
    try { window.lazySizes.loader.unveil(el); } catch (err) {}
  }

  function boot() {
    if (!window.lazySizes || !window.lazySizes.loader || !window.lazySizes.loader.unveil) { return; }
    var main = modal.querySelector('.product-gallery__carousel-item.is-selected img.lazyload')
            || modal.querySelector('.product-gallery__carousel-item img.lazyload');
    if (main) { unveil(main); }
    var thumbs = modal.querySelectorAll('.product-gallery__thumbnail img.lazyload');
    for (var i = 0; i < thumbs.length; i++) { unveil(thumbs[i]); }
  }

  requestAnimationFrame(function () { requestAnimationFrame(boot); });
  setTimeout(boot, 300);
  setTimeout(boot, 900);
});